import { render, staticRenderFns } from "./NftItemPreviewCard.vue?vue&type=template&id=5a236b80&"
import script from "./NftItemPreviewCard.vue?vue&type=script&lang=js&"
export * from "./NftItemPreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./NftItemPreviewCard.vue?vue&type=style&index=0&id=5a236b80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports